import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DesignBuildElevate from "./sections/DesignBuildElevate";
import ThePrimeGenMission from "./sections/ThePrimeGenMission";
import OurLandscapeExpertise from "./sections/OurLandscapeExpertise";
import SecureYourExpertConsultation from "./sections/SecureYourExpertConsultation";
import ServingTheNorthernCaliforniaCoast from "./sections/ServingTheNorthernCaliforniaCoast";
import OurImpactInNumbers from "./sections/OurImpactInNumbers";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DesignBuildElevate />
      <ThePrimeGenMission />
      <OurLandscapeExpertise />
      <SecureYourExpertConsultation />
      <ServingTheNorthernCaliforniaCoast />
      <OurImpactInNumbers />
      <Footer />
    </div>;
}